module.exports = __webpack_public_path__ + "static/media/046-tooth.c9f876e6.svg";